import { render, staticRenderFns } from "./ScriptShifter.vue?vue&type=template&id=2ba6b322&scoped=true&"
import script from "./ScriptShifter.vue?vue&type=script&lang=js&"
export * from "./ScriptShifter.vue?vue&type=script&lang=js&"
import style0 from "./ScriptShifter.vue?vue&type=style&index=0&id=2ba6b322&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba6b322",
  null
  
)

export default component.exports